module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1010-040c1380cd7968848446f0d14c318aa5.png";